export interface UserSelectItem {
  value: string;
  label: string;
}
